import { useState, useEffect } from 'react';

export const useTheme = () => {
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem('theme');
      if (saved === null) return true; // Default to dark theme
      
      // Handle both JSON and plain string values
      if (saved === 'true' || saved === 'false') {
        return saved === 'true';
      }
      
      return JSON.parse(saved);
    } catch (error) {
      console.warn('Error parsing theme from localStorage:', error);
      return true; // Default to dark theme if parsing fails
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('theme', JSON.stringify(isDark));
      
      if (isDark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    } catch (error) {
      console.warn('Error saving theme to localStorage:', error);
    }
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  return { isDark, toggleTheme };
};